import { createClient } from "@/shared/urql/urql";
import { GetCurrentUserFeatureFlagsDocument } from "@/shared/generated/graphql";
import { handleCombinedError } from "@/shared/helper/handleCombinedError.helper";
import { translateError } from "@/shared/helper/translateError.helper";

export const getCurrentUserFeatureFlags = async (customerId: string) => {
  const client = createClient();

  const { error, data } = await client
    .query(GetCurrentUserFeatureFlagsDocument, { customerId })
    .toPromise();

  if (error) throw handleCombinedError(error);
  if (!data) throw translateError("INTERNAL_ERROR");

  return data.currentUserFeatureFlags;
};
